import type { SchemaColumn, SchemaField } from '@cli-types/core-engine/schema.js'
import { quoteLiteral } from '@cli-utils/text.js'

export function getBooleanColumnLabels(
  column: SchemaColumn,
  fields: SchemaField[]
): { trueLabel: string; falseLabel: string } {
  const field = fields.find((item) => item.name === column.accessorKey)
  const baseLabel = field?.label || column.header
  const defaultLabels =
    column.accessorKey === 'published'
      ? { trueLabel: 'Published', falseLabel: 'Draft' }
      : { trueLabel: baseLabel, falseLabel: `Not ${baseLabel}` }

  return {
    trueLabel: quoteLiteral(column.trueLabel ?? defaultLabels.trueLabel),
    falseLabel: quoteLiteral(column.falseLabel ?? defaultLabels.falseLabel)
  }
}
